import styles from "@/components/pages/beats/styles/effect-setting-header.module.scss";
import {
  ALL_EFFECT_TITLES,
  EffectTitle,
} from "@/components/pages/beats/data/beats-effects.data";
import StyledDropdown from "@/components/common/styled-dropdown";
import DeleteButton from "@/components/common/command-buttons/delete-button";

type EffectSettingHeaderProps = {
  index: number;
  title: EffectTitle;
  description: string;
  changeEffectType: (index: number, effectType: EffectTitle) => void;
  removeEffect: (index: number) => void;
};

const EffectSettingHeader = ({
  index,
  title,
  description,
  changeEffectType,
  removeEffect,
}: EffectSettingHeaderProps) => {
  return (
    <div className={styles.header_wrapper}>
      <div className={styles.main_info_wrapper}>
        <div className={styles.index_text}>{index + 1}.</div>
        <div className={styles.dropdown_wrapper}>
          <StyledDropdown
            currentValue={title}
            values={[...ALL_EFFECT_TITLES]}
            onChanged={(value) => changeEffectType(index, value as EffectTitle)}
          />
        </div>
        <div className={styles.description_text}>{description}</div>
      </div>
      {index !== 0 && (
        <div className={styles.button_wrapper}>
          <DeleteButton
            isEnabled={true}
            handleClick={() => removeEffect(index)}
            hideText={true}
          />
        </div>
      )}
    </div>
  );
};

export default EffectSettingHeader;
